import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faEye,
  faPauseCircle,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
function Approval() {
  const [product, setProduct] = useState({
    // data: [
    //   {
    //     email: "pommuraj@next99.com",
    //     firstname: "pommu",
    //     lastname: "raj",
    //     mobile: "68676736723",
    //     portal_url: "pommu.com",
    //     status: "On hold",
    //   },
    //   {
    //     email: "nishaa@next99.com",
    //     firstname: "ni",
    //     lastname: "sha",
    //     mobile: "8888888888888",
    //     portal_url: "nisha.com",
    //     status: "Registered",
    //   },
    // ],
  });
  const [search, setSearch] = useState([""]);
  const [show, setShow] = useState(false);
  const [view, setView] = useState();

  //get all data
  const getProductData = async () => {
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_NODE_URL}/admin/publisher/unapproved`
      );

      console.log(data.data);
      setProduct(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getProductData();
  }, []);
  //view data in the table

  const getDataView = async (id) => {
    setShow(true);
    try {
      const data = await axios.get(
        `${process.env.REACT_APP_NODE_URL}/admin/publisher/unapproved/view/` +
        id
      );
      console.log("jhguhghug", data.data);
      setView(data.data.data[0]);
    } catch (e) {
      console.log(e);
    }
  };

  const getApproved = (id, url, email) => {
    const confirmationBox = window.confirm("Do you really want to approve?");
    if (confirmationBox === true) {
      axios
        .put(`${process.env.REACT_APP_NODE_URL}/admin/publisher/approve`, {
          mpi_id: id,
          status: 3,
          domain: url,
          email: email
        })
        .then(function (response) {
          if (response.data.status === 200) {
            getProductData();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  const getRejected = (id, url, email) => {
    const confirmationBox = window.confirm("Do you really want to reject?");
    if (confirmationBox === true) {
      axios
        .put(`${process.env.REACT_APP_NODE_URL}/admin/publisher/approve`, {
          mpi_id: id,
          status: 4,
          domain: url,
          email: email
        })
        .then(function (response) {
          if (response.data.status === 200) {
            alert("Rejected");
            getProductData();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  const getHoldOn = (id, url, email) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/admin/publisher/approve`, {
        mpi_id: id,
        status: 5,
        domain: url,
        email: email
      })
      .then(function (response) {
        if (response.data.status === 200) {
          alert("HoldOn");
          getProductData();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      <h2>Unapproved Publisher List</h2>
      <div className="text-end">
        <input
          type="text"
          placeholder="search here"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
        />
      </div>
      <div className="overflow-y-scroll px-5 py-3">
        <table className="table table-bordered border-primary table-hover ">
          <thead className="table-dark ">
            <tr>
              <th scope="col">S.NO</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">Website</th>
              <th scope="col">Status</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {console.log("product", product)}
            {product.data !== undefined
              ? product.data

                .filter((item) => {
                  if (search === "") {
                    return item;
                  } else if (
                    item.email.includes(search) ||
                    item.firstname.includes(search) ||
                    item.lastname.includes(search) ||
                    item.status.includes(search) ||
                    item.mobile.includes(search) ||
                    item.portal_url.includes(search)
                  ) {
                    return item;
                  }
                  console.log("Filter", item);
                })

                .map((item, index) => {
                  return (
                    <tr>
                      <th scope="row">{(index + 1)}</th>
                      <td>{item.firstname + item.lastname}</td>
                      <td>{item.email}</td>
                      <td>{item.mobile}</td>
                      <td>
                        <a href={"http://" + item.portal_url}>{item.portal_url}</a>
                      </td>
                      <td>{item.status}</td>
                      <td>
                        <Link to={`view/${item.mpi_id}`}>
                          <FontAwesomeIcon
                            icon={faEye}
                            title="view"
                            style={{ color: "#044389" }}
                          />
                        </Link>{" "}
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          title="Approve"
                          style={{ color: "#008000" }}
                          onClick={() => getApproved(item.mpi_id, item.portal_url, item.email)}
                        />{" "}
                        <FontAwesomeIcon
                          icon={faXmarkCircle}
                          title="Reject"
                          style={{ color: "#FF0000" }}
                          onClick={() => getRejected(item.mpi_id, item.portal_url, item.email)}
                        />{" "}
                        <FontAwesomeIcon
                          icon={faPauseCircle}
                          title="On Hold"
                          style={{ color: "#FF5733" }}
                          onClick={() => getHoldOn(item.mpi_id, item.portal_url, item.email)}
                        />
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </table>
      </div>
      <Modal show={show} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>View Unapproved List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {console.log("view", view)}

          {/* <p>
                  <label className="form-label">article_length:{view.article_length} </label>
                </p>
                <p>
                  <label className="form-label">blog_platform:{view.blog_platform} </label>
                </p>
                <p>
                  <label className="form-label">category:{view.category}</label>
                </p>
                <p>
                  <label className="form-label">description:{view.description}</label>
                </p>
                <p>
                  <label className="form-label">domain_authority:{view.domain_authority}</label>
                </p>
                <p>
                  <label className="form-label">dpr_id:{view.dpr_id}</label>
                </p>
                <p>
                  <label className="form-label">email: {view.email}</label>
                </p>
                <p>
                  <label className="form-label">email_verified:{view.email_verified}</label>
                </p>
                <p>
                  <label className="form-label">firstname:{view.firstname}</label>
                </p>
                <p>
                  <label className="form-label">lastname:{view.lastname}</label>
                </p> */}

          {/* <p>
                <label className="form-label">
                  ga_analytics:{view.ga_analytics}
                </label>
              </p>
              <p>
                <label className="form-label">languages:{view.languages}</label>
              </p>
              <p>
                <label className="form-label">
                  minimum_unique_user:{view.minimum_unique_user}
                </label>
              </p>
              <p>
                <label className="form-label">mpi_id:{view.mpi_id}</label>
              </p>
              <p>
                <label className="form-label">
                  parent_topic:{view.parent_topic}
                </label>
              </p>
              <p>
                <label className="form-label">
                  portal_name:{view.portal_name}
                </label>
              </p>
              <p>
                <label className="form-label">
                  portal_url:{view.portal_url}
                </label>
              </p>
              <p>
                <label className="form-label">
                  publishing_cost:{view.publishing_cost}
                </label>
              </p>
              <p>
                <label className="form-label">tags:{view.tags}</label>
              </p>
              <p>
                <label className="form-label">
                  target_country:{view.target_country}
                </label>
              </p> */}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
export default Approval;
